import { render } from "./SettingsMandate.vue?vue&type=template&id=ef06c3c0&scoped=true"
import script from "./SettingsMandate.vue?vue&type=script&lang=js"
export * from "./SettingsMandate.vue?vue&type=script&lang=js"

import "./SettingsMandate.vue?vue&type=style&index=0&id=ef06c3c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef06c3c0"]])

export default __exports__